import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import ModuleListContainer from './ModuleListContainer';
import Card from '../../../core/layout/Card';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import { Roles } from '../../../core/util';
import Tabs from '../../../core/layout/Tabs';

const ModuleListScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Modules',
        },
      ]}
    />
    {!!props.distributors.length && (
      <Tabs
        storeInUrl
        onChange={(tab) => props.onFilterChange('distributor', tab)}
        tabs={[
          ...([Roles.ADMIN, Roles.CONTENT_ADMIN, Roles.SUPPORT].includes(localStorage.role)
            ? [{ id: 'default', name: 'Default' }]
            : []),
          ...props.distributors,
        ].map((d) => ({
          key: d.id,
          title: d.name,
          content: (
            <Card
              title={`${d.name} - Courses and Modules`}
              loading={props.fetching}
              actions={
                [Roles.ADMIN, Roles.CONTENT_ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN].some(
                  (r) => r === localStorage.role
                ) && (
                  <Button
                    type="primary"
                    icon="plus"
                    onClick={() => browserHistory.push('/modules/new')}
                    label="New module"
                  />
                )
              }
            >
              {!!props.courses.length && (
                <Tabs
                  storeInUrl={false}
                  tabs={props.courses.map((course) => ({
                    key: course.id,
                    title: course.name,
                    content: <ModuleListContainer courseId={course.id} />,
                  }))}
                />
              )}
            </Card>
          ),
        }))}
      />
    )}
  </div>
);

ModuleListScene.propTypes = {
  fetching: PropTypes.bool.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, id: PropTypes.string })).isRequired,
  distributors: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, id: PropTypes.string })).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
};

export default ModuleListScene;
